import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import {
  ExpertClientsFilter,
  ExpertClientsGridFilterData,
  ExpertClientsGridRequest,
  ExpertClientsGridResponse,
  ExpertClientsGridResponseData,
  ExpertClientsSort,
} from 'projects/admin/src/app/models/experts/clientGridReqRes';

interface CheckBoxOptions {
  label: string;
  value: string;
  checked: boolean;
}

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrl: './table.component.scss',
})
export class TableComponent {
  @Input() inputTableData: ExpertClientsGridResponse | undefined;
  @Input() gridRequest: ExpertClientsGridRequest | undefined;

  @Output() resetFilterEvent = new EventEmitter<void>();
  @Output() pageSizeChangeEvent = new EventEmitter<number>();
  @Output() pageChangeEvent = new EventEmitter<number>();
  @Output() expertClientSortEvent = new EventEmitter<{sort: string | null,expertClients: ExpertClientsSort}>();
  @Output() partnerFilterEvent = new EventEmitter<string[]>();
  @Output() testUserEvents = new EventEmitter<boolean>();

  pageSize: number = 10;
  pageSizeOptions = [10, 20, 50, 100];
  listOfData: ExpertClientsGridResponseData[] = [];
  partnersCheckBoxOptions: CheckBoxOptions[] = [];
  selectedPartnerFilter: string[] = [];
  public readonly ExpertClientsSort = ExpertClientsSort

  constructor(private router: Router) {}

  nzPageIndexChange(page: number) {
    this.pageChangeEvent.emit(page);
  }

  nzPageSizeChange(pageSize: number) {
    this.pageSizeChangeEvent.emit(pageSize);
  }

  resetFilter() {
    this.resetFilterEvent.emit();
  }
  

  convertDateFormat(date: Date) {
    return moment(date, 'x').format('DD/MM/YYYY h:mm a');
  }

  sortExpertClient(sort: string | null,expertClients: ExpertClientsSort) {
    this.expertClientSortEvent.emit({sort,expertClients});
  }

  

  setPartnerFilterData(filterOptions?: ExpertClientsGridFilterData) {
    this.partnersCheckBoxOptions = [];
    filterOptions?.partners.forEach((cat) =>
     {
      if(this.gridRequest?.filters?.PARTNER?.includes(cat.partnerId)){
         this.partnersCheckBoxOptions.push({
        checked: true,
        label: cat.partnerName,
        value: cat.partnerId,
      })
      }else{
         this.partnersCheckBoxOptions.push({
        checked: false,
        label: cat.partnerName,
        value: cat.partnerId,
      })
      }
     }
    );
  }

  partnerFilterFn() {
    this.partnerFilterEvent.emit(this.selectedPartnerFilter);
  }

  partnerFilterChangeFn($event: string[]) {
    this.selectedPartnerFilter = $event;
  }

  resetValues() {
    this.pageSize = 10;
    this.selectedPartnerFilter = [];
    this.showTestCount = false;
  }

  openTherapyPlansSubscriptionPageByUser(userId: string) {
    window.open(`therapy-plans/subscriptions?userId=${userId}`);
  }

  openTherapyPacksSubscriptionPageByUser(userId: string) {
    window.open(`packs/subscription?userId=${userId}`);
  }
  showTestCount = false;
  showTestUsers(){
    this.testUserEvents.emit(this.showTestCount);
  }
}
